export default class PermissionConstants {
	public static readonly ApplicationName = 'SurveyBuilderAPI';
	public static readonly AuthAPIName = 'AuthAPI';

	public static readonly SURVEYBUILDER_ALL = {
		resource: 'Survey Builder',
		permission: 'All',
		application: PermissionConstants.ApplicationName,
	};

	public static readonly HIERARCHYREPORTING_ALL = {
		resource: 'Hierarchy Reporting Configuration',
		permission: 'All',
		application: PermissionConstants.ApplicationName,
	};
}
